import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Luggage.svg",
  "use": "Luggage.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Luggage.svg\"><path d=\"M44,56a2,2,0,0,1-2,2H40a2,2,0,0,1-2-2H26a2,2,0,0,1-2,2H22a2,2,0,0,1-2-2,4,4,0,0,1-4-4V20a4,4,0,0,1,4-4h2V7a5,5,0,0,1,5-5H37a5,5,0,0,1,5,5v9h2a4,4,0,0,1,4,4V52A4,4,0,0,1,44,56ZM38,7a1,1,0,0,0-1-1H27a1,1,0,0,0-1,1v9H38Zm3,17H23a1,1,0,1,0,0,2H41a1,1,0,0,0,0-2Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol